import React, { FC } from 'react';
import s from './historySection.module.scss';
import { artist, toy } from '@specs/specs';
import { useTranslation } from '@hooks/useTranslation';
import { useGetToyHistory } from '@hooks/TRPC_Hooks/useGetToyHistory';
import { ToyHistoryItem } from '@components/Cards/ToyHistoryItem/ToyHistoryItem';
import { ToyHistoryArtistItem } from '@components/Cards/ToyHistoryItem/ToyHistoryArtistItem';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { EmptyList } from '@components/UIKit/EmptyList/EmptyList';
import { InViewHookResponse } from 'react-intersection-observer';
interface Props {
  inView: InViewHookResponse['inView'];
  blockRef: InViewHookResponse['ref'];
  toyId: toy['id'];
  artistId: artist['id'] | undefined;
}
export const HistorySection: FC<Props> = ({
  inView,
  artistId,
  toyId,
  blockRef
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: history,
    isLoading: historyLoading
  } = useGetToyHistory({
    toyId,
    limit: 4
  }, {
    enabled: inView
  });
  const isLoading = historyLoading;
  return <div className={s.historySection} ref={blockRef} data-sentry-component="HistorySection" data-sentry-source-file="HistorySection.tsx">
            <div className={s.historySection__title}>
                {tr({
        id: 'toy.page.history.title'
      })}
            </div>
            <div className={s.historySection__list}>
                {isLoading ? <LogoLoader /> : !history?.length && typeof artistId !== 'number' ? <EmptyList /> : <>
                        {history?.map(item => <ToyHistoryItem key={item.id} {...item} />)}
                        {typeof artistId === 'number' && <ToyHistoryArtistItem toyId={toyId} artistId={artistId} />}
                    </>}
            </div>
        </div>;
};